import { consumeUnsubscribeFragment } from './services/unsubscribeLink';

// Imported second by index.js, right after impersonationPreInit. ES modules run in import order, so on /unsubscribe
// the emailed token leaves the URL fragment, and the tab is marked for analytics, before any other module evaluates.
consumeUnsubscribeFragment();
